var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "60", height: "60", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", preserveAspectRatio: "xMidYMid", className: styles["lds-rolling"] || "lds-rolling", style: {
        background: "0 0"
      } }, props),
    React.createElement(
      "circle",
      { cx: "50", cy: "50", fill: "none", stroke: "#018489", strokeWidth: "10", r: "30", strokeDasharray: "141.37166941154067 49.12388980384689", transform: "rotate(115.638 50 50)" },
      React.createElement("animateTransform", { attributeName: "transform", type: "rotate", calcMode: "linear", values: "0 50 50;360 50 50", keyTimes: "0;1", dur: "1.4s", begin: "0s", repeatCount: "indefinite" })
    )
  );
});